import {
  saveCandidateFeedback,
  submitAssessment,
  BASE_URL,
} from "../services/assessment.api";
import { store } from "../store";
import { setCameraStatus, setIsCameraRequired } from "../store/Camera/action";
import {
  setIsScreenShared,
  setIsScreenSharingRequired,
} from "../store/Screen/actions";
import { setFullScreen, setIsSubmitted } from "../store/Test/action";
import { exitFullScreen } from "./fullscreen";

/**
 * Submits the assessment data to the server.
 * @param {Object} feedbackData - Optional feedback data to save before submission
 * @param {number} feedbackData.experienceRating - Rating for experience (1-5)
 * @param {number} feedbackData.questionRating - Rating for questions (1-5)
 * @param {string} feedbackData.feedback - Optional feedback text
 */
const handleSubmit = async (feedbackData = null) => {
  const currentSpentTime = store.getState().candidateReducer.time || 0;
  const testId = store.getState().testReducer.testId;
  const candidateId = store.getState().candidateReducer.id;

  // Step 1: Save feedback if provided
  if (
    feedbackData &&
    feedbackData.experienceRating &&
    feedbackData.questionRating
  ) {
    try {
      console.log("Saving feedback");
      await saveCandidateFeedback({
        assessmentId: testId,
        candidateAssessmentId: candidateId,
        experienceRating: feedbackData.experienceRating,
        questionRating: feedbackData.questionRating,
        feedback: feedbackData.feedback || "",
      });
      console.log("Feedback saved successfully");
    } catch (error) {
      console.error("Error saving feedback:", error);
    }
  }

  // Step 2: Submit the test

  const requestBody = {
    candidateAssessmentId: candidateId,
    totalTimeSpent: currentSpentTime,
    tabSwitchCount: store.getState().candidateReducer.tab,
    fullScreenExitCount: store.getState().candidateReducer.count || 0,
  };

  // Use the new unified API service
  try {
    const response = await submitAssessment(testId, requestBody);

    // Success - cleanup
    localStorage.removeItem("hasExecuted");
    // await exitFullScreen().catch(() => {});
    // store.dispatch(setFullScreen(false));
    store.dispatch(setIsCameraRequired(false));
    store.dispatch(setCameraStatus(false));
    store.dispatch(setIsScreenSharingRequired(false));
    store.dispatch(setIsScreenShared(false));

    return response;
  } catch (error) {
    console.error("Failed to submit the test", error);
    throw error;
  }
};

export { handleSubmit };
